require("../src/bootstrap");

import "../src/invest.js";
import "../stylesheets/invest.scss";
